<nav class="navbar fixed-top">
  <div class="container-fluid">
    <div class="navbar-desktop">
      <a class="navbar-brand white-logo-vid" href="./index.html"
        ><img
          src="assets/images/jpeg-optimizer_2021322124955-522vidhema-logopurewhite.webp"
          alt="Vidhema Company Logo"
          title="logopurewhite"
      /></a>
      <a class="navbar-brand dark-logo-vid" href="index.html">
        <img src="assets/images/vidhema-logo-black.png" alt="Vidhema"  title="vidhema-logo-black"/>
      </a>
      <!--header-menu-->

      <div class="custom-navbar desktop-nav">
        <nav class="navbar-menu">
          <div id="navbar-w" class="navbar-collapse navigation-part">
            <ul class="menu-links">
              <li class="submenu">
                <a
                  href="javascript:void(0)"
                  class="transition main-menu-title"
                  tabindex="-1"
                  >Company
                  <i class="fa fa-caret-down" aria-hidden="true"></i>
                </a>
                <div class="dropdown-menu-max col-md-12" style="display: block">
                  <div class="sub-menu-section">
                    <div class="container-fluid" style="padding: 0 !important">
                      <div class="col-md-12">
                        <div class="sub-menu-center-block rows" style="">
                          <div
                            class="btn-block solution-link digital-patership"
                          >
                            <h4>Digital Partnerships</h4>
                            <div
                              class="partner-image-adobe"
                              loading="lazy"
                            ></div>
                            <div
                              class="partner-image-salesforce"
                              loading="lazy"
                            ></div>
                            <div
                              class="partner-image-shopify"
                              loading="lazy"
                            ></div>
                          </div>
                          <div class="outer-sub-menu-sec menu-spacing">
                            <div class="sub-menu-sec">
                              <div class="menuHeadTitle">
                                <img
                                  src="assets/images/favicon.ico"
                                  alt="Vidhema Icon Logo"
                                  title="favicon"
                                  srcset=""
                                />
                                Why Vidhema
                              </div>
                              <ul>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/about-us.html"
                                    tabindex="-1"
                                    >About Us</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/career.html"
                                    tabindex="-1"
                                    >Career</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/blog"
                                    tabindex="-1"
                                  >
                                    Blog</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/contact-us.html"
                                    tabindex="-1"
                                    >Contact Us</a
                                  >
                                </li>
                                <!-- <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/about-us.html"
                                    tabindex="-1"
                                    >Life at Vidhema</a
                                  >
                                </li> -->
                              </ul>
                            </div>

                            <div class="block">
                              <div class="block1">
                                <h3 class="">Our Expertise</h3>
                                <p>
                                  Vidhema Technologies has a proven record of
                                  developing websites, applications, and
                                  software. We are proud to be the top-most
                                  choice in the tech market for leading
                                  enterprises and have offered our services to
                                  many clients around every corner of the world.
                                </p>
                              </div>
                              <div class="block2">
                                <h3 class="">Our Environment</h3>
                                <p>
                                  When a company can rely on its employees is
                                  the best honor they could get. An excellent
                                  work environment with good opportunities makes
                                  an employee work efficiently. Combining all
                                  these factors is an inspiration that can boost
                                  their career. We are thrilled and gratified
                                  for the people who work fervently with us to
                                  build a great workplace!
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="submenu">
                <a
                  href="javascript:void(0)"
                  class="transition main-menu-title"
                  tabindex="-1"
                  >Solutions
                  <i class="fa fa-caret-down" aria-hidden="true"></i
                ></a>
                <div
                  class="dropdown-menu-max col-md-12 Microsoft-Services-li"
                  style="display: block"
                >
                  <div class="sub-menu-section">
                    <div class="container-fluid" style="padding: 0 !important">
                      <div class="col-md-12">
                        <div class="sub-menu-center-block cus-full-block rows">
                          <!-- <div class="btn-block highlight-link">
                            <div>
                              <a
                                routerlink="/blog"
                                (click)="addClickEvent(false)"
                                class="comman-btn mt14 btn"
                                tabindex="-1"
                                >Blog</a
                              >
                            </div>
                            <div>
                              <a
                                routerLink="/hire-magento-developers.html"
                                (click)="addClickEvent(false)"
                                class="comman-btn btn"
                                tabindex="-1"
                                >Outsource with Us</a
                              >
                            </div>
                          </div> -->
                          <div class="outer-sub-menu-sec">
                            <div class="sub-menu-sec sub-menu-sec-mobile">
                              <div class="menuHeadTitle">
                                <i class="fa fa-mobile"></i>Microsoft 
                              </div>
                              <!-- <ul class="mt16">
                                <li
                                  class="service-category"
                                  (click)="addClickEvent(false)"
                                  routerLink="/microsoft-365.html"
                                >
                                  <a>Microsoft  365</a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/microsoft-azure.html"
                                    >Microsoft  Azure
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/microsoft-dynamic.html"
                                    >Microsoft  Dynamic
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/microsoft-native.html"
                                    >Microsoft  Native
                                  </a>
                                </li>
                              </ul> -->
                              <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/microsoft-business-controller.html"
                                    >Microsoft  Business Controller
                                  </a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/microsoft-power-bi.html"
                                    >Microsoft  Power BI
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div class="outer-sub-menu-sec">
                            <div class="sub-menu-sec sub-menu-sec-mobile">
                              <div class="menuHeadTitle">
                                <i class="fa fa-mobile"></i>ERP Solutions
                              </div>
                              <ul class="mt16">
                                <li
                                  class="service-category"
                                  (click)="addClickEvent(false)"
                                  routerLink="/microsoft-dynamic.html"
                                >
                                  <a>Microsoft  Dynamics</a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/oracle-development.html"
                                    >Oracle Solutions
                                  </a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/odoo-development.html"
                                    >Odoo Solutions
                                  </a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/sap-solution.html"
                                    >SAP Solutions
                                  </a>
                                </li>
                              </ul>
                             
                            </div>
                          </div>
                          <div class="outer-sub-menu-sec">
                            <div class="sub-menu-sec sub-menu-sec-mobile">
                              <div class="menuHeadTitle">
                                <i class="fa fa-mobile"></i>CRM Solutions
                              </div>
                              <ul class="mt16">
                                <li
                                  class="service-category"
                                  (click)="addClickEvent(false)"
                                  routerLink="/microsoft-365.html"
                                >
                                  <a>Microsoft  365</a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/salesforce-development.html"
                                    >SalesForce 
                                  </a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hubspot.html"
                                    >HubSpot
                                  </a>
                                </li>
                              </ul>
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -native.html"
                                    >Microsoft  Native
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -business-controller.html"
                                    >Microsoft  Business Controller
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -power-BI.html"
                                    >Microsoft  Power BI
                                  </a>
                                </li>
                              </ul> -->
                            </div>
                          </div>
                          <div class="outer-sub-menu-sec">
                            <div class="sub-menu-sec sub-menu-sec-mobile">
                              <div class="menuHeadTitle">
                                <i class="fa fa-mobile"></i>Data Analytics
                              </div>
                              <!-- <ul class="mt16">
                                <li
                                  class="service-category"
                                  (click)="addClickEvent(false)"
                                  routerLink="/microsoft-power-bi.html"
                                >
                                  <a>Power BI</a>
                                </li>
                              </ul> -->
                              <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/tableau.html"
                                    >Tableau Solutions
                                  </a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="adobe-experience.html"
                                    >Adobe Experience
                                  </a>
                                </li>
                              </ul>
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -native.html"
                                    >Microsoft  Native
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -business-controller.html"
                                    >Microsoft  Business Controller
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -power-BI.html"
                                    >Microsoft  Power BI
                                  </a>
                                </li>
                              </ul> -->
                            </div>
                          </div>
                          <div class="outer-sub-menu-sec">
                            <div class="sub-menu-sec sub-menu-sec-mobile">
                              <div class="menuHeadTitle">
                                <i class="fa fa-mobile"></i>Cloud Solutions
                              </div>
                              <ul class="mt16">
                                <li
                                  class="service-category"
                                  (click)="addClickEvent(false)"
                                  routerLink="/microsoft-azure.html"
                                >
                                  <a> Microsoft  Azure</a>
                                </li>
                              </ul>
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -azure.html"
                                    >Microsoft  Azure
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -dynamic.html"
                                    >Microsoft  Dynamic
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -native.html"
                                    >Microsoft  Native
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -business-controller.html"
                                    >Microsoft  Business Controller
                                  </a>
                                </li>
                              </ul> -->
                              <!-- <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/Microsoft -power-BI.html"
                                    >Microsoft  Power BI
                                  </a>
                                </li>
                              </ul> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="submenu">
                <a
                  href="javascript:void(0)"
                  class="transition main-menu-title"
                  tabindex="-1"
                  >Services <i class="fa fa-caret-down" aria-hidden="true"></i
                ></a>
                <div class="dropdown-menu-max col-md-12" style="display: block">
                  <div class="sub-menu-section">
                    <div class="container-fluid" style="padding: 0 !important">
                      <div class="col-md-12">
                        <div class="sub-menu-center-block cus-full-block rows">
                          <!-- <div class="btn-block highlight-link">
                            <div>
                              <a
                                routerlink="/blog"
                                (click)="addClickEvent(false)"
                                class="comman-btn mt14 btn"
                                tabindex="-1"
                                >Blog</a
                              >
                            </div>
                            <div>
                              <a
                                routerLink="/hire-magento-developers.html"
                                (click)="addClickEvent(false)"
                                class="comman-btn btn"
                                tabindex="-1"
                                >Outsource with Us</a
                              >
                            </div>
                          </div> -->
                          <div class="outer-sub-menu-sec">
                            <div class="sub-menu-sec sub-menu-sec-mobile">
                              <div class="menuHeadTitle">
                                <i class="fa fa-mobile"></i> Mobile
                              </div>
                              <ul class="mt16">
                                <li
                                  class="service-category"
                                  (click)="addClickEvent(false)"
                                  routerLink="/ios-app-development.html"
                                >
                                  <a>iOS</a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/android-app-development.html"
                                    >Android</a
                                  >
                                </li>

                              <!-- <li class="service-category submenu-name nameee">
                                Hybrid
                              </li> -->
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/flutter-development.html"
                                    tabindex="-1"
                                    >Flutter</a
                                  >
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/ionic-development.html"
                                    tabindex="-1"
                                    >Ionic</a
                                  >
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/react-native.html"
                                    tabindex="-1"
                                    >React Native</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <div class="sub-menu-sec">
                              <div class="menuHeadTitle">
                                <i class="fa fa-desktop" aria-hidden="true"></i>
                                Web
                              </div>
                              <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/front-end-development.html"
                                    tabindex="-1"
                                    >Front End Development</a
                                  >
                                </li>

                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/ecommerce-development.html"
                                    tabindex="-1"
                                    >Ecommerce Website Development Services</a
                                  >
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/cms-development.html"
                                    tabindex="-1"
                                    >CMS Web Development Company</a
                                  >
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/web-application-development.html"
                                    tabindex="-1"
                                    >Web Application Development Services</a
                                  >
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/js-based-full-stack-development.html"
                                    tabindex="-1"
                                    >Javascript Web Development Company</a
                                  >
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/youtube-marketing-services.component.html"
                                    tabindex="-1"
                                  >
                                    YouTube Marketing Services</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <div class="sub-menu-sec">
                              <div class="menuHeadTitle">
                                <i
                                  class="fa fa-cloud-upload"
                                  aria-hidden="true"
                                ></i
                                >Emerging Technologies
                              </div>
                              <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/nft-development.html"
                                  >
                                    NFT Development
                                  </a>
                                </li>

                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/augumented-reality.html"
                                  >
                                    Augmentation Reality (AR) Implementation
                                  </a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/progressive-web-app-development.html"
                                    tabindex="-1"
                                    >Progressive Web Development</a
                                  >
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/aem-cms-development.html"
                                    tabindex="-1"
                                    >AEM CMS Development</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <div class="sub-menu-sec">
                              <div class="menuHeadTitle">
                                <i
                                  class="fa fa-cloud-upload"
                                  aria-hidden="true"
                                ></i
                                >Digital Commerce
                              </div>
                              <ul class="mt16">
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/magento-development.html"
                                  >
                                    Magento Development Company
                                  </a>
                                </li>

                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/shopify-development.html"
                                  >
                                    Shopify Development Company
                                  </a>
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/shopware-development.html"
                                    tabindex="-1"
                                    >Shopware Development Company</a
                                  >
                                </li>
                                <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/prestashop.html"
                                    tabindex="-1"
                                    >PrestaShop Development Services</a
                                  >
                                </li>
                                <!-- <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/salesforce-development.html"
                                    tabindex="-1"
                                    >Salesforce Consulting</a
                                  >
                                </li> -->
                                <!-- <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/oracle-development.html"
                                    tabindex="-1"
                                  >
                                    Oracle Solutions</a
                                  >
                                </li> -->
                                <!-- <li class="service-category">
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/odoo-development.html"
                                    tabindex="-1"
                                  >
                                    Odoo Solutions</a
                                  >
                                </li> -->
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="submenu">
                <a
                  href="javascript:void(0)"
                  class="transition main-menu-title"
                  tabindex="-1"
                  >Hire Resource
                  <i class="fa fa-caret-down" aria-hidden="true"></i
                ></a>
                <div class="dropdown-menu-max col-md-12" style="display: block">
                  <div class="sub-menu-section">
                    <div class="container-fluid" style="padding: 0 !important">
                      <div class="col-md-12">
                        <div class="sub-menu-center-block rows">
                          <div
                            class="btn-block solution-link digital-patership"
                          >
                            <h4>Digital Partnerships</h4>
                            <div class="partner-image-adobe"></div>
                            <div class="partner-image-salesforce"></div>
                            <div class="partner-image-shopify"></div>
                          </div>
                          <div class="outer-sub-menu-sec technologies-sec">
                            <div class="sub-menu-sec">
                              <div class="menuHeadTitle">
                                <i class="fa fa-desktop" aria-hidden="true"></i
                                >Web
                              </div>
                              <ul>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-java-developers.html"
                                    tabindex="-1"
                                    >Java</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-dotnet-developers.html"
                                    tabindex="-1"
                                    >.Net</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-php-developers.html"
                                    tabindex="-1"
                                    >PHP</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-python-developers.html"
                                    tabindex="-1"
                                    >Python</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <div class="sub-menu-sec">
                              <div class="menuHeadTitle">
                                <i class="fa fa-mobile"></i>Mobile
                              </div>
                              <ul>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-android-developers.html"
                                    tabindex="-1"
                                    >Android</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-ios-developers.html"
                                    tabindex="-1"
                                    >iOS</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-flutter-developers.html"
                                    tabindex="-1"
                                    >Flutter</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-react-native-developers.html"
                                    tabindex="-1"
                                    >React Native</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-ionic-developers.html"
                                    tabindex="-1"
                                    >Ionic</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <div class="sub-menu-sec without-heading">
                              <div class="menuHeadTitle">
                                <i
                                  class="fa fa-shopping-cart"
                                  aria-hidden="true"
                                ></i
                                >E-Commerce
                              </div>
                              <ul>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-shopify-developers.html"
                                    tabindex="-1"
                                    >Shopify
                                  </a>
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-magento-developers.html"
                                    tabindex="-1"
                                    >Magento</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-shopware-developers.html"
                                    tabindex="-1"
                                    >Shopware</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-woocommerce-developers.html"
                                    tabindex="-1"
                                    >WooCommerce</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <div class="sub-menu-sec without-heading">
                              <div class="menuHeadTitle">
                                <i class="fa fa-laptop" aria-hidden="true"></i
                                >CMS
                              </div>
                              <ul>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-wordpress-developers.html"
                                    tabindex="-1"
                                    >WordPress
                                  </a>
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-drupal-developers.html"
                                    tabindex="-1"
                                    >Drupal</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-wix-developers.html"
                                    tabindex="-1"
                                    >Wix
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div class="sub-menu-sec without-heading">
                              <div class="menuHeadTitle">
                                <i class="fa fa-jsfiddle"></i>JS Framework
                              </div>
                              <ul>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-vue-js-developers.html"
                                    tabindex="-1"
                                    >Vue JS</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-angular-js-developers.html"
                                    tabindex="-1"
                                    >Angular JS</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-node-js-developers.html"
                                    tabindex="-1"
                                    >Node JS</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-react-js-developers.html"
                                    tabindex="-1"
                                    >React JS</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <div class="sub-menu-sec without-heading">
                              <div class="menuHeadTitle">
                                <img
                                  src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/nft-icon.png?alt=media&token=6d2666e2-8b8c-41e2-a827-dac352fb2db5"
                                  alt="NFT Icon"
                                  title="nft-icon"
                                />
                                NFT / <i class="fa fa-btc"></i>Blockchain
                              </div>
                              <ul>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-nft-ecommerce-developers.html"
                                    tabindex="-1"
                                    >NFT E-Commerce</a
                                  >
                                </li>
                                <li>
                                  <a
                                    (click)="addClickEvent(false)"
                                    routerLink="/hire-nft-marketplace-developers.html"
                                    tabindex="-1"
                                    >NFT Marketplace</a
                                  >
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li class="submenu">
                <a
                  (click)="addClickEvent(false)"
                  routerLink="/portfolio.html"
                  class="transition main-menu-title"
                  tabindex="-1"
                  >Our Portfolio</a
                >
              </li>

              <!-- <li class="submenu">
                                <a (click)="addClickEvent(false)" routerLink="/career" class="transition main-menu-title" tabindex="-1">Career</a>
                            </li> -->
              <li class="submenu">
                <a
                  routerLink="/case-studies.html"
                  class="transition main-menu-title"
                  id="InquireNow"
                  tabindex="-1"
                  >Case Studies</a
                >
              </li>
            </ul>
          </div>

          <!-- <div class="ba-we-love-subscribers-wrap">
                        <div class="ba-we-love-subscribers popup-ani" [ngClass] = "toggle? 'open' : ''">
                            <header>
                                <h4>For HR Inquiry</h4>
                                <a href="tel:+919352372844" style="width: 100%;display: block;margin: 10px auto;">(+91)9352372844</a>
                            </header>
                            <div>
                                <h4>For Sales / Consultation</h4>
                                <a href="tel:+6580151152" style="width: 100%;display: block;margin: 10px auto;">(+65)80151152</a>
                                <a href="tel:+917976109930" style="width: 100%;display: block;margin: 10px auto;">(+91)7976109930</a>
                            </div>
                        </div>
                        <div class="ba-we-love-subscribers-fab" (click) = "updateToggle()">
                            <div class = "wrap" [ngClass] = "toggle? 'ani' : ''">
                                <div class="img-fab img osc-rotation" [ngClass] = "toggle? 'close' : ''">
                                    <i class="icon bgc-blue c-white circle p-5">phone</i>
                                </div>
                            </div>
                        </div> -->
          <!-- </div> -->

          
          
          <div class="inquiry-btn">
            <!-- <div class="header">
              <a href="https://wa.me/917976109930" target="_blank" class="whats" title="Call Us">
                <img
                  loading="lazy"
                  width="35px"
                  height="35px"
                  class="brand-logo-img"
                  src="assets/images/whatsapp (1).gif"
                  style="cursor: pointer"
                  alt="WhatsApp Button"
                  title="whatsapp"
                />
              </a>
            </div> -->
            <a
              class="a-link"
              (click)="addClickEvent(false)"
              routerLink="/contact-us.html"
              class="transition main-menu-title cta-btn"
              tabindex="-1"
              >Contact Us</a
            >
          </div>
        </nav>
      </div>
    </div>

    <!--header-menu-->

    <button
      class="navbar-toggler mobile-menu"
      type="button"
      data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasNavbar"
      aria-controls="offcanvasNavbar"
    >
      <span
        ><i
          class="fa fa-bars hamburger hamburger-white"
          aria-hidden="true"
          style="color: var(--whitecolor)"
        ></i
      ></span>
    </button>
    <div
      class="mobile-menu-section"
      tabindex="-1"
      id=""
      aria-labelledby="offcanvasNavbarLabel"
    >
      <div class="offcanvas-header">
        <button type="button" class="btn-close btn-close-menu"></button>
      </div>
      <div class="offcanvas-body">
        <div class="logo">
          <img src="assets/images/vidhema-logo-black.png" alt="Vidhema Logo"  title="vidhema-logo-black"/>
        </div>
        <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
          <li class="nav-item dropdown" (click)="changeRole('Company')">
            <a class="nav-link active dropdown-toggle" role="button"
              ><span>Company</span></a
            >

            <ul
              *ngIf="type == 'Company'"
              aria-labelledby="offcanvasNavbarDropdown"
            >
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/about-us.html"
                  tabindex="-1"
                  >About Us</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  class="anchor-mobile"
                  routerLink="/career.html"
                  tabindex="-1"
                  >Career</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerlink="/blog"
                  tabindex="-1"
                  >Our Blog</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/contact-us.html"
                  tabindex="-1"
                  >Contact Us</a
                >
              </li>

              <li>
                <a
                  (click)="closebox()"
                  routerLink="/about-us.html"
                  tabindex="-1"
                  >Life at Vidhema</a
                >
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown" (click)="changeRole('Mobile')">
            <a class="nav-link active dropdown-toggle" role="button"
              ><span>Mobile</span></a
            >

            <ul
              *ngIf="type == 'Mobile'"
              aria-labelledby="offcanvasNavbarDropdown"
            >
              <li>
                <a (click)="closebox()" routerLink="/ios-app-development.html"
                  >iOS</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/android-app-development.html"
                  >Android</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/flutter-development.html"
                  tabindex="-1"
                  >Flutter</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/ionic-development.html"
                  tabindex="-1"
                  >Ionic</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/react-native.html"
                  tabindex="-1"
                  >React Native</a
                >
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown" (click)="changeRole('Web')">
            <a class="nav-link active dropdown-toggle" role="button"
              ><span>Web</span></a
            >

            <ul *ngIf="type == 'Web'" aria-labelledby="offcanvasNavbarDropdown">
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/front-end-development.html"
                  tabindex="-1"
                  >Front End Development</a
                >
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/progressive-web-app-development.html"
                  tabindex="-1"
                  >Progressive Web Development</a
                >
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/ecommerce-development.html"
                  tabindex="-1"
                  >Ecommerce Website Development Services</a
                >
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/cms-development.html"
                  tabindex="-1"
                  >CMS Web Development Company</a
                >
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/web-application-development.html"
                  tabindex="-1"
                  >Web Application Development Services</a
                >
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/js-based-full-stack-development.html"
                  tabindex="-1"
                  >Javascript Web Development Company</a
                >
              </li>
            </ul>
          </li>

          <li
            class="nav-item dropdown"
            (click)="changeRole('Emerging Technologies')"
          >
            <a class="nav-link active dropdown-toggle" role="button"
              ><span>Emerging Technologies</span></a
            >

            <ul
              *ngIf="type == 'Emerging Technologies'"
              aria-labelledby="offcanvasNavbarDropdown"
            >
              <li class="service-category">
                <a (click)="closebox()" routerLink="/nft-development.html">
                  NFT Development
                </a>
              </li>
              <li class="service-category">
                <a (click)="closebox()" routerLink="/augumented-reality.html">
                  Augmentation Reality (AR) Implementation
                </a>
              </li>
            </ul>
          </li>
          <li
            class="nav-item dropdown"
            (click)="changeRole('Microsoft  Services')"
          >
            <a
              class="nav-link active dropdown-toggle"
              role="button"
              tabindex="-1"
            >
              <span>Microsoft  Services</span>
            </a>
            <ul
              *ngIf="type == 'Microsoft  Services'"
              aria-labelledby="offcanvasNavbarDropdown"
            >
              <li
                class="service-category"
                (click)="closebox()"
                routerLink="/microsoft-365.html"
              >
                <a>Microsoft  365</a>
              </li>

              <li class="service-category">
                <a (click)="closebox()" routerLink="/microsoft-azure"
                  >Microsoft  Azure
                </a>
              </li>
              <li class="service-category">
                <a (click)="closebox()" routerLink="/microsoft-dynamic"
                  >Microsoft  Dynamic
                </a>
              </li>
              <li class="service-category">
                <a (click)="closebox()" routerLink="/microsoft-native"
                  >Microsoft  Native
                </a>
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/microsoft-business-controller"
                  >Microsoft  Business Controller
                </a>
              </li>
              <li class="service-category">
                <a (click)="closebox()" routerLink="/microsoft-power-Bi"
                  >Microsoft  Power BI
                </a>
              </li>
            </ul>
          </li>
          <li
            class="nav-item dropdown"
            (click)="changeRole('Digital Commerce')"
          >
            <a class="nav-link active dropdown-toggle" role="button"
              ><span>Digital Commerce</span></a
            >

            <ul
              *ngIf="type == 'Digital Commerce'"
              aria-labelledby="offcanvasNavbarDropdown"
            >
              <li class="service-category">
                <a (click)="closebox()" routerLink="/magento-development.html">
                  Magento Development Company
                </a>
              </li>

              <li class="service-category">
                <a (click)="closebox()" routerLink="/shopify-development.html">
                  Shopify Development Company
                </a>
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/shopware-development.html"
                  tabindex="-1"
                  >Shopware Development Company</a
                >
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/salesforce-development.html"
                  tabindex="-1"
                  >Salesforce
                </a>
              </li>
              <li class="service-category">
                <a
                  (click)="closebox()"
                  routerLink="/oracle-development.html"
                  tabindex="-1"
                  >Oracle
                </a>
              </li>
            </ul>
          </li>
          <li class="nav-item dropdown" (click)="changeRole('Technologies')">
            <a class="nav-link"><span>Hire Developer</span></a>
            <ul *ngIf="type == 'Technologies'">
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-java-developers.html"
                  tabindex="-1"
                  >Java</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-dotnet-developers.html"
                  tabindex="-1"
                  >.Net</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-php-developers.html"
                  tabindex="-1"
                  >PHP</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-python-developers.html"
                  tabindex="-1"
                  >Python</a
                >
              </li>

              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-android-developers.html"
                  tabindex="-1"
                  >Android</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-ios-developers.html"
                  tabindex="-1"
                  >iOS</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-flutter-developers.html"
                  tabindex="-1"
                  >Flutter</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-react-native-developers.html"
                  tabindex="-1"
                  >React Native</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-ionic-developers.html"
                  tabindex="-1"
                  >Ionic</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-shopify-developers.html"
                  tabindex="-1"
                  >Shopify
                </a>
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-magento-developers.html"
                  tabindex="-1"
                  >Magento</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-shopware-developers.html"
                  tabindex="-1"
                  >Shopware</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-woocommerce-developers.html"
                  tabindex="-1"
                  >WooCommerce</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-wordpress-developers.html"
                  tabindex="-1"
                  >WordPress
                </a>
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-drupal-developers.html"
                  tabindex="-1"
                  >Drupal</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-wix-developers.html"
                  tabindex="-1"
                  >Wix
                </a>
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-vue-js-developers.html"
                  tabindex="-1"
                  >Vue JS</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-angular-js-developers.html"
                  tabindex="-1"
                  >Angular JS</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-node-js-developers.html"
                  tabindex="-1"
                  >Node JS</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-react-js-developers.html"
                  tabindex="-1"
                  >React JS</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-nft-ecommerce-developers.html"
                  tabindex="-1"
                  >NFT E-Commerce</a
                >
              </li>
              <li>
                <a
                  (click)="closebox()"
                  routerLink="/hire-nft-marketplace-developers.html"
                  tabindex="-1"
                  >NFT Marketplace</a
                >
              </li>
            </ul>
          </li>
          <li class="submenu">
            <a
              (click)="closebox()"
              routerLink="/portfolio.html"
              class="transition"
              tabindex="-1"
              >Our Portfolio</a
            >
          </li>

          <li class="submenu">
            <a
              (click)="closebox()"
              routerlink="/blog"
              class="transition"
              tabindex="-1"
              >Blogs</a
            >
          </li>
          <li class="submenu">
            <a
              (click)="closebox()"
              routerLink="/career.html"
              class="transition"
              tabindex="-1"
              >Career</a
            >
          </li>
          <li class="submenu">
            <a
              (click)="closebox()"
              routerLink="/contact-us.html"
              class="transition"
              tabindex="-1"
              >Contact Us</a
            >
          </li>
          <li class="submenu">
            <a
              (click)="closebox()"
              routerLink="/case-studies.html"
              class="transition quote-button"
              tabindex="-1"
              >Case Studies</a
            >
          </li>
          <li class="submenu">
            <a
              (click)="closebox()"
              routerLink="/getaquote.html"
              class="transition quote-button"
              tabindex="-1"
              >Get a Quote</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</nav>
